/**
 * Modal de reconocimiento de racha de 5 días
 * Se muestra cuando el usuario alcanza racha de 5 días (5 estrellas)
 */

import { useEffect } from 'react';
import { StarRating } from './StarRating';
import './StreakAchievementModal.css';

interface StreakAchievementModalProps {
  streak5Count: number;
  onClose: () => void;
}

export function StreakAchievementModal({ streak5Count, onClose }: StreakAchievementModalProps) {
  useEffect(() => {
    // Prevenir scroll del body cuando el modal está abierto
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="streak-modal-overlay" onClick={handleOverlayClick}>
      <div className="streak-modal-content">
        <div className="streak-modal-header">
          <div className="streak-modal-stars">
            <StarRating streak={5} animated={true} />
          </div>
          <h2 className="streak-modal-title">¡Felicidades! 🎉</h2>
        </div>

        <div className="streak-modal-body">
          <p className="streak-modal-message">
            Has alcanzado una racha de <strong>5 días</strong> consecutivos
          </p>
          <p className="streak-modal-submessage">
            {streak5Count === 1
              ? '¡Esta es tu primera racha de 5 días!'
              : `¡Esta es tu racha número ${streak5Count} de 5 días!`}
          </p>
          <p className="streak-modal-motivation">
            ¡Sigue así y mantén tu racha activa!
          </p>
        </div>

        <div className="streak-modal-footer">
          <button className="streak-modal-button" onClick={onClose}>
            <img 
              src="/assets/ui/botones/Botón Aceptar.png" 
              alt="Continuar"
              className="streak-modal-button-image"
            />
          </button>
        </div>

        {/* Efectos visuales de celebración */}
        <div className="celebration-effects">
          {Array.from({ length: 20 }).map((_, i) => (
            <div
              key={i}
              className="confetti"
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 0.5}s`,
                animationDuration: `${1 + Math.random() * 0.5}s`,
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

